import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-moda-editar',
  templateUrl: './moda-editar.component.html',
  styleUrl: './moda-editar.component.scss'
})
export class ModaEditarComponent implements OnInit {
  @Output() confirmEdit = new EventEmitter<any>();
  @ViewChild('staticDataModal') staticDataModal!: TemplateRef<any>;
  @Input() payload: any;

  editarForm!: FormGroup;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder) { }

  get tipoDeCalculo(): number | undefined {
    return this.payload?.tipoDeCalculo;
  }

  get isTipoCalculo3(): boolean {
    return this.tipoDeCalculo === 3;
  }

  ngOnInit(): void {
    this.editarForm = this.fb.group({
      id: [""],
      grupoId: [""],
      nome: ["", [Validators.required]],
      valor: ["", [Validators.required]],
      metroQuadrado: [""],
      metroQuadradoAdicional: [""]
    })
  }
  openModal(): void {
    this.editarForm.reset();

    if (this.payload) {
      this.editarForm.patchValue({
        id: this.payload.item.id,
        grupoId: this.payload.grupoId,
        nome: this.payload.item.nome, 
        valor: this.removeCurrencyPrefix(this.payload.item.valor),
        metroQuadrado: this.payload.item.metroQuadrado || "",
        metroQuadradoAdicional: this.payload.item.metroQuadradoAdicional || ""
      });
    }

    if (this.staticDataModal) {
      this.modalService.open(this.staticDataModal, { centered: true });
    } else {
      console.error('Modal template is not available!');
    }
  }

  confirm(): void {

    const formValues = this.editarForm.value;

    // Emitindo o evento para o componente pai
    this.confirmEdit.emit(formValues);
    //this.modalService.dismissAll(); // Fecha o modal
  }

  closeModal(){
    this.modalService.dismissAll();
  }

  // TODO INPUT MASK CURRENCY
  // Quando um input tem mask de valor monetário.
  // para preencher o valor do input. 
  // primeiro é preciso remover R$, preencher o valor e depois adicionar anovamente
  private removeCurrencyPrefix(value: string): string {
    // Remove o prefixo "R$ " e retorna somente o número
    return value ? value.replace('R$ ', '').replace('.', '').replace(',', '.') : '';
  }
}
